import { render, staticRenderFns } from "./msg_list.vue?vue&type=template&id=2c134ffe&scoped=true&"
import script from "./msg_list.vue?vue&type=script&lang=ts&"
export * from "./msg_list.vue?vue&type=script&lang=ts&"
import style0 from "./msg_list.vue?vue&type=style&index=0&id=2c134ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c134ffe",
  null
  
)

export default component.exports